import encodedWasm from './pkg/palbe_mls_bg.wasm';

// Built as a private package-import target. Keeping the bytes in their own
// lazily imported JavaScript module lets browser bundlers carry/split the MLS
// engine without a public-path convention, while Node ESM and CJS resolve the
// exact same package-owned bytes.
export default encodedWasm;
